<div (click)="goBack()" *ngIf="backIcon" [ngClass]="{'alchemist-box' : !backIconWork}" class="touch-eff back-box">
    <img *ngIf="!backIconWork" [src]="userService.companyLogoSmall" alt="back" class="back alchemist desktop-only">
    <img *ngIf="backIconWork" [ngClass]="{'hide930' : hide930}" src="assets/img/{{userService.headerMode === 'light' ? 'back-black.svg' : 'back-white.svg'}}" alt="back" class="back white-img">
</div>
<div class="space" *ngIf="!backIcon"></div>

<figure *ngIf="middleIcon" (click)="middleIconLink && goHome()" alt="logo" class="logo logo-desktop desktop-only logo-desktop-{{middleIconSize}}" [ngStyle]="{'background-image': 'url('+userService.companyLogo+')'}"></figure>
<figure *ngIf="!headerTitle && middleIconMobile" (click)="middleIconLink && goHome()" alt="logo" class="logo logo-mobile mobile-only" [ngStyle]="{'background-image': 'url('+userService.companyLogo+')'}"></figure>

<div *ngIf="!!headerTitle" class="header-title content-wrap-inner">
    <img class="side-logo" [src]="userService.companyLogo">
    <div class="header-text" [innerHTML]="headerTitle"></div>
</div>

<div *ngIf="socialIcons && userService.userInfo?.client_id !== 134" class="header-buttons-wrap content-wrap-inner">
    <div *ngIf="socialIcon" (click)="goToSocial()" class="header-button-wrap">
        <span class="header-btn-text">{{ "__COMPONENTS_HEADER_SOCIAL_STREAM__" | translate }}</span>
        <button class="icon social-stream"></button>
    </div>
    <div *ngIf="leaderboardIcon" (click)="goToLeaderboard()" class="header-button-wrap margin-left">
        <span class="header-btn-text">{{ "__COMPONENTS_HEADER_GLOBAL_LEADERBOARD__" | translate }}</span>
        <button class="icon leaderboard"></button>
    </div>
</div>

<div class="menu" *ngIf="menuIcon">
    <ion-menu-toggle>
        <img src="assets/img/{{userService.headerMode === 'light' ? 'menu-black.svg' : 'menu-white.svg'}}" alt="btn" class="btn white-img">
    </ion-menu-toggle>
</div>

<div class="space" *ngIf="!menuIcon"></div>

<div class="menu" *ngIf="false && menuIcon" (click)="getActionLogOut()">
    <img src="assets/img/menu/door.svg" alt="btn" class="btn white-img">
</div>
